/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      d="M9.5.25c-.9665 0-1.75.7835-1.75 1.75h1.5a.25.25 0 0 1 .5 0v1a.75.75 0 0 0 1.5 0V2c0-.9665-.7835-1.75-1.75-1.75Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M1.5 18.5v-8c0-3.867 2.66-7.1115 6.25-8.0057V2h1.5v1.7384l-.626.105C5.4323 4.3788 3 7.156 3 10.5v8h13.75V16a.75.75 0 0 1 1.5 0v2.5H19a.75.75 0 0 1 0 1.5h-5.75c0 2.0711-1.6789 3.75-3.75 3.75-2.071 0-3.75-1.6789-3.75-3.75h-5a.75.75 0 0 1 0-1.5h.75ZM11.75 20c0 1.2426-1.0074 2.25-2.25 2.25S7.25 21.2426 7.25 20h4.5Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M18.5 7c0 .5523-.4477 1-1 1s-1-.4477-1-1 .4477-1 1-1 1 .4477 1 1Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M20.4654 11.0261a4.9725 4.9725 0 0 1-2.2154.918v.8059a.75.75 0 0 1-1.5 0v-.8059a4.9725 4.9725 0 0 1-2.2154-.918l-.5701.5701a.75.75 0 0 1-1.0607-1.0607l.5701-.57a4.9728 4.9728 0 0 1-.918-2.2155H11.75a.75.75 0 0 1 0-1.5h.8059a4.9728 4.9728 0 0 1 .918-2.2154l-.5701-.5701a.75.75 0 1 1 1.0607-1.0607l.5701.5701a4.9736 4.9736 0 0 1 2.2154-.918V1.25a.75.75 0 0 1 1.5 0v.8059a4.9736 4.9736 0 0 1 2.2154.918l.5701-.57a.75.75 0 0 1 1.0607 1.0606l-.5701.57a4.9728 4.9728 0 0 1 .918 2.2155h.8059a.75.75 0 0 1 0 1.5h-.8059a4.9728 4.9728 0 0 1-.918 2.2154l.5701.5701a.75.75 0 0 1-1.0607 1.0607l-.5701-.5701ZM21 7c0 1.933-1.567 3.5-3.5 3.5S14 8.933 14 7s1.567-3.5 3.5-3.5S21 5.067 21 7Z"
      clipRule="evenodd"
    />
  </React.Fragment>,
  'MenuAlertConfiguration'
);
